import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App/App.tsx';
import { BrowserRouter } from "react-router-dom"
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.style = 'margin: 0; padding: 0;'

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
    <BrowserRouter basename='/jampad-web'>
      <App />
    </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
